
import React from 'react';

interface SelectionSummaryProps {
  selectedCount: number;
  totalCount: number;
}

const SelectionSummary = ({ selectedCount, totalCount }: SelectionSummaryProps) => {
  if (selectedCount === 0) return null;
  
  return (
    <div className="mt-4 text-sm text-gray-500">
      {selectedCount} de {totalCount} lignes sélectionnées.
    </div>
  );
};

export default SelectionSummary;
